const capabilities = {
    app: ['loader', 'paginator', 'filter', 'sorter', 'exporter', 'error-logger'],
    entity: ['workflow']
};

export default capabilities;
